exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".overlay {\n  position: fixed;\n  background-color: white;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  opacity: 0.8;\n  -moz-opacity: 0.8;\n  filter: alpha(opacity=80);\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";\n  z-index: 10000;\n}\n\n.overlay img {\n  position: absolute;\n  left: 45%;\n  top: 40%;\n  width: 100px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading-spinner/loading-spinner.component.css
// module id = 507
// module chunks = 0